import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Uninstall a component
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestDeleteInstalledComponent = packet => {
  return {
    type: 'REQUEST_DELETE_INSTALLED_COMPONENT',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveDeleteInstalledComponentSuccess = data => ({
  type: 'RECEIVE_DELETE_INSTALLED_COMPONENT_SUCCESS',
  data
})

export const receiveDeleteInstalledComponentFail = data => ({
  type: 'RECEIVE_DELETE_INSTALLED_COMPONENT_FAIL',
  data
})

export const tryToDeleteInstalledComponent = packet => (dispatch, getState) => {

  dispatch(requestDeleteInstalledComponent(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/projects/installed-component/' + packet.id + '/' + packet.component_id, {
      method: 'delete',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveDeleteInstalledComponentSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveDeleteInstalledComponentFail({errors:e, lastSubmit: packet}));
    })
}
